/* External dependencies */
import { AnyAction, applyMiddleware, combineReducers, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/logOnlyInProduction';
import { createEpicMiddleware } from 'redux-observable';
import CognitoClient from '@mancho.devs/cognito';

/* Local dependencies */
import getDevices from '../components/devices/getDevices/redux/reducer';
import { authReducer } from '../components/webApp/authredux/reducer';
import { modalReducer } from '../components/webApp/modal/redux/reducer';
import { rootEpic } from '../components/webApp/authredux/epics';

const rootReducer = combineReducers({
  auth: authReducer,
  modal: modalReducer,
  getDevices,
});

export type RootState = ReturnType<typeof rootReducer>;

const cognito = new CognitoClient({
  UserPoolId: process.env.GATSBY_COGNITO_USER_POOL_ID!,
  ClientId: process.env.GATSBY_COGNITO_CLIENT_ID!,
});

const epicMiddleware = createEpicMiddleware<
  AnyAction,
  AnyAction,
  RootState,
  { cognito: CognitoClient }
>({
  dependencies: { cognito },
});

export const store = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(epicMiddleware))
);

epicMiddleware.run(rootEpic);

export type AppDispatch = typeof store.dispatch;